module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/nervousness/290c2b57659798e2e74c601557d5cea2.png";